import * as _ from 'lodash'

export function getGeocoderResult(results: google.maps.GeocoderResult[]) {
  const _result = getGeocoderResultV2(results)
  const filteredResult = results.filter(result => !contains(result, ['plus_code']))
  if (filteredResult.length == 0) return null
  const result = filteredResult[0]
  const { countryCode, city } = countryAndCity(filteredResult)
  const zipcode = getComponent(result, ['postal_code'])
  const buildingName = getComponent(result, ['premise', 'establishment', 'point_of_interest'])
  return {
    countryCode,
    city,
    zipcode,
    address: result.formatted_address,
    buildingName,
    street: _result.street,
    locality: _result.locality,
    adminRegion: _result.administrativeArea
  }
}

function contains(item: google.maps.GeocoderResult, componentTypes: string[]): boolean {
  return _.flatten(item
    .address_components
    .map(component => component.types))
    .some(value => componentTypes.includes(value))
}

function typesContains(item: string[], componentTypes: string[]): boolean {
  return item.some(value => componentTypes.includes(value))
}

function getComponent(item: google.maps.GeocoderResult | undefined, componentTypes: string[], longName: boolean = true): string | null {
  if (!item) return null;
  const component = item.address_components.filter(component => {
    const includes = componentTypes.map(type => component.types.includes(type)).filter(value => value === true)
    return includes.length > 0
  })    
  if (component.length == 0) return null
  if (longName) return component[0].long_name
  return component[0].short_name
}

function countryAndCity(results: google.maps.GeocoderResult[]) {
  const cityFilter = ['administrative_area_level_1', 'locality', 'administrative_level_1']
  const politicalResult = results.find(result => typesContains(result.types, cityFilter))
  const countryCode = getComponent(politicalResult, ['country'], false)
  const city = getComponent(politicalResult, cityFilter)
  return {
    countryCode,
    city
  }
}

function getGeocoderResultV2(results: google.maps.GeocoderResult[]) {
  const streetKeywords = ['street_address']
  const localityKeywords = ['sublocality', 'sublocality_level_1']
  const administrativeKeywords = ['administrative_area_level_1', 'administrative_area_level_2'];
  const street = getResult(results, streetKeywords)
  const locality = getResult(results, localityKeywords)
  const administrativeArea = getResult(results, administrativeKeywords)
  return {
    street: getStreetFromComponent(street),
    locality: getValueFromComponent(locality, localityKeywords),
    administrativeArea: getValueFromComponent(administrativeArea, administrativeKeywords),
  }
}

function getStreetFromComponent(result: google.maps.GeocoderResult | null) {
  if (!result) return null;
  const numComponent = result.address_components.find(component => component.types.includes('street_number'))
  const routeComponent = result.address_components.find(component => component.types.includes('route'));
  if (!routeComponent) return null;
  if (numComponent) {
    return `${numComponent.long_name} ${routeComponent?.long_name}`
  }
  return routeComponent.long_name 
}

function getValueFromComponent(result: google.maps.GeocoderResult | null, keywords: string[]) {
  if (!result) return null;
  const components = result.address_components.filter(component => {
    const includes = keywords.map(keyword => component.types.includes(keyword)).filter(value => value === true)
    return includes.length > 0
  })
  if (components.length == 0) return null;
  return components[0].long_name
}

function getResult(results: google.maps.GeocoderResult[], keywords: string[]) {
  let _result: google.maps.GeocoderResult | null = null
  for (let i = 0; i < keywords.length; i++) {
    const keyword = keywords[i]
    for (let j = 0; j < results.length; j++) {
      const result = results[j]
      if (result.types.includes(keyword)) {
        _result = result
        break;
      }
    }

    if (_result) {
      break;
    }
  }

  return _result
}